module.exports = __webpack_public_path__ + "media/images/ac_templates/201/ingo-18e5674bc1f635da40799f9993619f49.jpg";